/**
 * Utility to capture redirect URL before Router redirects to login
 * This runs immediately when the script loads, before any React components
 */

// Capture redirect URL immediately when script loads
(function captureRedirectUrl() {
	// Always capture the current URL if it has query parameters
	const currentPath = window.location.pathname;
	const currentSearch = window.location.search;

	// Check if we have query parameters or if it's not a public route
	const publicRoutes = ['/lac', '/', '/auth/login', '/rules', '/home'];
	const hasQueryParams = currentSearch && currentSearch.length > 0;
	const isNotPublicRoute = !publicRoutes.includes(currentPath);

	// Capture if we have query params OR if it's not a public route
	if (hasQueryParams || isNotPublicRoute) {
		const fullUrl = window.location.href;
		const url = new URL(fullUrl);
		const searchParams = new URLSearchParams(url.search);

		// Remove identity parameter if it exists
		searchParams.delete('identity');
		const cleanSearch = searchParams.toString();
		const redirectUrl = url.pathname + (cleanSearch ? `?${cleanSearch}` : '');

		localStorage.setItem('redirectUrl', redirectUrl);
	}
})();

// Also capture on beforeunload to catch any navigation
window.addEventListener('beforeunload', function () {
	const currentPath = window.location.pathname;
	const currentSearch = window.location.search;
	const publicRoutes = ['/lac', '/', '/auth/login', '/rules', '/home'];

	if (currentSearch && currentSearch.length > 0 && !publicRoutes.includes(currentPath)) {
		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);
		searchParams.delete('identity');
		const cleanSearch = searchParams.toString();
		const redirectUrl = url.pathname + (cleanSearch ? `?${cleanSearch}` : '');

		localStorage.setItem('redirectUrl', redirectUrl);
	}
});

// Capture on popstate (back/forward navigation)
window.addEventListener('popstate', function (event) {
	const currentPath = window.location.pathname;
	const currentSearch = window.location.search;
	const publicRoutes = ['/lac', '/', '/auth/login', '/rules', '/home'];

	if (currentSearch && currentSearch.length > 0 && !publicRoutes.includes(currentPath)) {
		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);
		searchParams.delete('identity');
		const cleanSearch = searchParams.toString();
		const redirectUrl = url.pathname + (cleanSearch ? `?${cleanSearch}` : '');

		localStorage.setItem('redirectUrl', redirectUrl);
	}
});

export default {};
